<template>
    <div class="quotesinfo">
        <UserHeaderMenu/>
        <div class="container mt-3">
            <div class="row justify-content-left"><router-link to="/deliveryNotes"><b-col lg="4" class="pb-2"><b-button :style="{'background':companyData.color, 'border':'none'}" size="sm">Vissza</b-button></b-col></router-link>
                <b-col lg="0" class="pb-2"><b-button :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="createPDF">Megtekintés PDF ként</b-button></b-col>
				<!--<b-col lg="2" v-if="mainData.megrendelve == 0" class="pb-2"><b-button :style="{'background':companyData.color, 'border':'none'}" size="sm" @click="order">Megrendelem</b-button></b-col>-->
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <h5 class="mt-3">Szállítási adatok</h5>
                    <div class="col-lg-12 border mt-3">
                        <div class="row">
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Cégnév:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.cegnev}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Cím:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.cim_orszag+" "+mainData.cim_ir+" "+mainData.cim_varos+", "+mainData.cim_utca+" "+mainData.cim_hazszam+" ("+mainData.cim_egyeb+")"}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Kiállító neve:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.kiall_nev}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Kiállítás:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.kiall_datum+" "+mainData.kiall_ido}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Szállító neve:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.szallito}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Szállító szám:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.szallito_szam}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Szállítás dátuma:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.szall_datum}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Vevő neve:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.vevo_nev}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Vevő cim:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.vevo_orszag+" "+mainData.vevo_ir+" "+mainData.vevo_varos+", "+mainData.vevo_utca+" "+mainData.vevo_hazszam}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Összsúly:
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top">
                                {{mainData.osszsuly}} {{mainData.ossz_suly_merteke}}
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data">
                                Számla
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top" v-if="mainData.szamla == 0">
                                Nem kér számlát
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top" v-else>
                                Igényel számlát
                            </div>
                            <div class="col-lg-3 bg-light-gray p-2 pl-5 left-data" v-if="mainData.bank_nev != ' '">
                                Bankszámla
                            </div>
                            <div class="col-lg-9 p-2 pl-5 border-top" v-if="mainData.bank_nev != ' '">
                                {{mainData.bank_szam}} ({{mainData.bank_nev}})
                            </div>

                        </div>
                    </div>
                    <h5 class="mt-3 d-none d-md-block d-lg-block">Szállítási tételek</h5>
                    <div class="col-lg-12 border mt-3">
                        <div class="row bg-light-gray">
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                <span class="d-none d-lg-block d-md-block">Szállító szám</span>
                            </div>
                            <div class="d-block d-lg-none d-md-none col-12 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                Szállítási tételek
                            </div>
                            <div class="d-none d-lg-block d-md-block col-2 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                Megnevezés
                            </div>
                            <div class="d-none d-lg-block d-md-block col-2 p-2 pl-lg-5 pl-md-5 pl-0 left-data">
                                Azonosító
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                <span class="d-none d-lg-block d-md-block">Mennyiség</span>
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                <span class="d-none d-lg-block d-md-block">Súly egység</span>
                            </div>
                            <div class="col-2 p-2 pl-0 pl-lg-5 pl-md-5 left-data">
                                <span class="d-none d-lg-block d-md-block">Súly Összesen</span>
                            </div>
                        </div>
                        <div class="row overflow-auto" v-for="item in toolsData" :key="item.sorszam">
                            <div class="col-md-2 p-2 pl-lg-5 pl-md-5 border-top">
                                {{item.szallito_szam}}
                            </div>
                            <div class="col-md-2 p-2 pl-lg-5 pl-md-5 border-top">
                                {{item.megnev}}
                            </div>
                            <div class="col-md-2 p-2 pl-lg-5 pl-md-5 border-top">
                                {{item.azonosito}}
                            </div>
                            <div class="col-md-2 p-2 pl-lg-5 pl-md-5 border-top">
                                {{item.mennyiseg+" "+item.menny_egyseg}}
                            </div>
                            <div class="col-md-2 p-2 pl-lg-5 pl-md-5 border-top">
                                {{item.suly_egyseg}} {{item.egyseg_suly_mertek}}
                            </div>
                            <div class="col-md-2 p-2 pl-lg-5 pl-md-5 border-top">
                                {{item.suly_ossz}} {{item.ossz_suly_merteke}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SettingsModal/>
    </div>
</template>
<script>
import jsPDF from 'jspdf'
import axios from 'axios'
import SettingsModal from '../components/SettingsModal.vue'
import UserHeaderMenu from '../components/UserHeaderMenu.vue'

export default {
  components: {
    SettingsModal,
    UserHeaderMenu
  },
  name: 'quotesinfo',
data(){
    return {
		product_image:[],
        mainData:[],
        toolsData:[],
		companyData:[],
		prodImage64:"",
        base64Header:"",
		base64Logo:"",
		prodImage:""
      }
    },
    computed: {
      
	},
    methods:{
        numberWithSpace(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        setImgSrc(img){
            return "https://admin.promagic.hu/api/uploads/"+img;
		},
        createPDF () {
            let pdfName = this.mainData.szallito_szam;
            const doc = new jsPDF();
            //Banner behúzás
            for (let peldany = 1; peldany < 4; peldany++) {
                doc.setFontStyle("bold");
                doc.setFontSize(15);
                doc.text("Szállító levél - tekercses címke", 5, 10);
                doc.setLineWidth(0.5);
                doc.line(5, 15, 200, 15);
                doc.setFontSize(10);
                doc.text("Szállító:", 5, 20);
                doc.setFontSize(13);
                doc.text("Promagic Hungary Kft.", 5, 27);
                doc.setFontSize(10);
                doc.text("7878 Debrecen,", 5, 33);
                doc.text("Lámpa u 21.", 5, 38);
                doc.setFontSize(8);
                doc.text("Adószám: 10275003-2-20", 5, 50);
                doc.text("Bankszámlaszám: RTZ BANK: 1111111-1111111-1111111", 5, 54);
                doc.line(5, 57, 200, 57);
                doc.line(110, 15, 110, 57);
                //Árajánlat rendelési adatok
                doc.setFontSize(10);
                doc.text("Átvetö: "+this.mainData.cegnev.replace('ő', 'ö').replace('ű', 'ü'), 115, 25);
                doc.text(this.mainData.cim_ir+" "+this.mainData.cim_varos.replace('ő', 'ö').replace('ű', 'ü')+", "+this.mainData.cim_utca.replace('ő', 'ö').replace('ű', 'ü')+" "+this.mainData.cim_hazszam.replace('ő', 'ö').replace('ű', 'ü'), 115, 31);
                doc.line(110, 37, 200, 37);
                doc.text("Vevö: "+this.mainData.vevo_nev.replace('ő', 'ö').replace('ű', 'ü'), 115, 45);
                doc.text(this.mainData.vevo_ir+" "+this.mainData.vevo_varos.replace('ő', 'ö').replace('ű', 'ü')+", "+this.mainData.vevo_utca.replace('ő', 'ö').replace('ű', 'ü')+" "+this.mainData.vevo_hazszam.replace('ő', 'ö').replace('ű', 'ü'), 115, 51);
                doc.line(5, 67, 200, 67);
                doc.text("Kiszállítás ideje: "+this.mainData.szall_datum, 5, 63);
                doc.line(70, 57, 70, 67);
                doc.text("Példány: "+peldany+"/3", 73, 63);
                doc.line(140, 57, 140, 67);
                doc.text("Szállító száma: " + this.mainData.szallito_szam, 143, 63);
                doc.line(5, 77, 200, 77);
                doc.line(140, 67, 140, 77);
                doc.line(70, 67, 70, 77);
                doc.text("Szállítás idöpontja: " + this.mainData.szall_datum, 5, 73);
                doc.text("Összsúly: " + this.mainData.osszsuly+" "+this.mainData.ossz_suly_merteke , 73, 73);
                doc.text("Szállító neve: " + this.mainData.szallito, 143, 73);
                doc.text("Szám", 5, 82);
                doc.text("Megnevezés", 20, 82);
                doc.text("Mennyiség", 160, 82);
                doc.text("M.e.", 190, 82);
                var i=90;
                for (let index = 0; index < this.toolsData.length; index++) {
                    this.addNewElementToRow(doc, i, this.toolsData[index].sorszam, this.toolsData[index].megnev.replace('ő', 'ö').replace('ű', 'ü'), this.toolsData[index].mennyiseg, this.toolsData[index].menny_egyseg, this.toolsData[index].suly_ossz, this.toolsData[index].ossz_suly_merteke, this.toolsData[index].suly_egyseg, this.toolsData[index].egyseg_suly_mertek, this.toolsData[index].azonosito, this.toolsData[index].cikk_szam)
                    i+=20;
                }
                doc.setFontSize(8);
                doc.text(this.mainData.szoveg_alulra.replace('ő', 'ö').replace('ű', 'ü'), 5, i);
                doc.line(5, 246, 200, 246);
                doc.text("Az ügyvitel minden folyamatáról a PROCESS MAGIC PRESS gondoskodik - KEZÉBE ADJUK AZ IRÁNYÍTÁST! - www.promagic.hu", 5, 250);
                doc.line(5, 253, 200, 253);
                doc.setFontSize(10);
                doc.text("PROMAGIC HUNGARY KFT.", 5, 258);
                doc.setFontSize(8);
                doc.text("7878. Debrecen, Lámpa u 21.", 5, 262);
                doc.text("Adószám: 10275003-2-20", 5, 266);
                if(this.prodImage != " " && this.prodImage != "" && this.prodImage != null){
                    doc.addImage('data:image/jpeg;base64,'+this.prodImage64, "JPEG", 5, 270, 30, 18);
                }
                doc.text("kiállító: "+this.mainData.kiall_nev, 5, 293);
                doc.line(140, 253, 140,296);
                doc.line(70, 253, 70, 296);
                doc.text("P.H.", 103, 272);
                doc.text("átvevö aláírása", 96, 293);
                doc.text("P.H.", 170, 272);
                doc.text("szállító aláírása", 162, 293);
                if(peldany != 3){
                    doc.addPage();
                }
            }
            doc.save(pdfName + '.pdf');
        },



        addNewElementToRow(doc ,i, szam, megnevezes, mennyiseg, menny_egyseg,ossz_suly,ossz_suly_merteke, egyseg_suly,egyseg_suly_mertek,munka_azon,cikkszam){
            doc.setFontStyle("bold");
            doc.text(szam, 5, i)
            doc.text(megnevezes, 20, i)
            doc.text(mennyiseg, 160, i)
            doc.text(menny_egyseg, 190, i)
            i+=5;
            doc.text("Termék súlya: "+egyseg_suly+" "+egyseg_suly_mertek+" X "+ mennyiseg+" "+menny_egyseg+" = "+ossz_suly+" "+ossz_suly_merteke , 20, i)
            i+=5;
            doc.text("Munka azonosító: "+munka_azon+" - Cikkszám: "+cikkszam , 20, i)
            i+=5;
            doc.line(5, i, 200, i);
        },
        sendQuotes(){
            let params = new URLSearchParams();
            params.append('sendQuotes', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_DELIVER_API,
                data:params
            }).then(() => {
                this.mainData.statusz = "Kiküldve"
            })
        },
        loadMainData(){
            let params = new URLSearchParams();
            params = new URLSearchParams();
            params.append('getThisQuotesData', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_DELIVER_API,
                data:params
            }).then((response) => {
                this.mainData = response.data[0]
                this.prodImage = response.data[0].alairas_kep
            })
        },
        loadToolsData(){
            let params = new URLSearchParams();
            params = new URLSearchParams();
            params.append('getThisQuotesToolsData', true);
            params.append('quotesID', this.$route.params.id);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_DELIVER_API,
                data:params
            }).then((response) => {
                this.toolsData = response.data
            })
        },
		loadLastProductImage(){
                    const params4 = new URLSearchParams();
                    params4.append('convertImageToBase64', true);
                    params4.append('url', this.prodImage);
                    params4.append('user_id', this.$session.get('id'));
                    axios({
                        method: 'post',
                        url: process.env.VUE_APP_DELIVER_API,
                        data:params4
                    }).then((response) => {
                        this.prodImage64 = response.data
                    })
        },
        getCompanyData(){
            const params = new URLSearchParams();
            params.append('getCompanyData', true);
            params.append('user_id', this.$session.get('id'));
            axios({
                method: 'post',
                url: process.env.VUE_APP_LOGIN_API,
                data:params
            }).then((response) => {
                console.log(response.data[0])
                this.companyData = response.data[0]
                const params2 = new URLSearchParams();
                params2.append('convertImageToBase64', true);
                params2.append('url', this.companyData.pdf_header);
                params2.append('user_id', this.$session.get('id'));
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_DELIVER_API,
                    data:params2
                }).then((response) => {
                    this.base64Header = response.data
                })
                const params3 = new URLSearchParams();
                params3.append('convertImageToBase64', true);
                params3.append('url', this.companyData.logo_src);
                params3.append('user_id', this.$session.get('id'));
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_DELIVER_API,
                    data:params3
                }).then((response) => {
                    this.base64Logo = response.data
				})
				this.loadLastProductImage()
            })
        },
        moneyFormatting(price, type){
            return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: type }).format(price);
        },
    },
    mounted(){
        this.loadMainData()
        this.loadToolsData()
		this.getCompanyData()
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Merienda&display=swap');
.bg-light-gray{
    background:#e5e5e5;
}
.left-data{
    font-weight: bold;
    font-size: 12pt;
}
</style>
